const TENANT_SCOPED_PREFIXES = [
  "/approvals",
  "/categories",
  "/companies",
  "/dashboard",
  "/delivery_notes",
  "/invoices",
  "/members",
  "/prices",
  "/products",
  "/purchase_requests",
  "/quote_items",
  "/quotes",
  "/request_items",
  "/sectors",
  "/suppliers",
] as const;

function isAbsoluteUrl(url: string) {
  return url.startsWith("http://") || url.startsWith("https://");
}

export function resolveAnnouncementUrl(
  url: string,
  organizationSlug?: string | null,
) {
  if (!url) return url;

  const trimmed = url.trim();
  if (!trimmed) return url;
  if (!organizationSlug) return trimmed;
  if (isAbsoluteUrl(trimmed)) return trimmed;
  if (trimmed.startsWith("mailto:") || trimmed.startsWith("tel:")) return trimmed;
  if (!trimmed.startsWith("/")) return trimmed;
  if (trimmed.startsWith("/organizations/")) return trimmed;

  const shouldScope = TENANT_SCOPED_PREFIXES.some((prefix) => {
    return (
      trimmed === prefix ||
      trimmed.startsWith(`${prefix}/`) ||
      trimmed.startsWith(`${prefix}?`) ||
      trimmed.startsWith(`${prefix}#`)
    );
  });

  if (!shouldScope) return trimmed;

  return `/organizations/${organizationSlug}${trimmed}`;
}
